import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../constants/constants';

export const componentKey = "PAYER_DROPDOWN";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },

        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },

        setPayersList: (state, action) => {
            const plainPayerList = Array.from(state.payersList);
            const plainPayload = Array.from(action.payload);

            let combinedArray = [...plainPayerList, ...plainPayload]

            const filteredArray = Object.values(
                combinedArray.reduce((acc, obj) => {
                    acc[obj.PayerDetailId] = obj;
                    return acc;
                }, {})
            );

            state.payersList = filteredArray
        },

        setPayersPaginationState: (state, action) => {
            state.payersPaginationState = { ...state.payersPaginationState, ...action.payload }
        },
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.LOADING, message: '' },

        // Payer
        selectedPayer: { label: '', value: '' },
        payersList: [],

        payersPaginationState: {
            PageNumber: 1,
            PageSize: 20,
            FilterText: "",
            IsDesc: true,
            IdNumber: "",
            Skip: 0,
            totalPayers: 10,
        },
    }
});

export const { setLoadingState, setSelectedPayer, setSelectedRecipient, setPayersList, setPayersPaginationState } = actions;